function convertToHeaders(xhrHeaders) {
    const headers = new Headers();
    const headerPairs = xhrHeaders.split('\r\n');
    for (const headerPair of headerPairs) {
        if (headerPair) {
            const [key, value] = headerPair.split(': ');
            headers.append(key, value);
        }
    }
    return headers;
}
export function convertToApiResponse(xmlHttpRequest) {
    const { status, responseText, statusText, responseURL } = xmlHttpRequest;
    const ok = status >= 200 && status < 300;
    const allResponseHeaders = xmlHttpRequest.getAllResponseHeaders();
    const headers = convertToHeaders(allResponseHeaders);
    return {
        headers,
        ok,
        status,
        statusText,
        url: responseURL,
        data: responseText ? JSON.parse(responseText) : {},
    };
}
//# sourceMappingURL=convertToApiResponse.js.map